<siq-video-player #videoPlayer (completed)="completed.emit()"></siq-video-player>
<siq-image-player #imagePlayer (completed)="completed.emit()"></siq-image-player>
